import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../capabilities';
import { getPortalId } from '../../common/utils';
import { GROW_GUIDE_COMPONENT } from '../constants';
import { getGrowGuideQueryParams } from './internal';
import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../constants/z_index';
export const growGuideComponentDef = defineComponent(GROW_GUIDE_COMPONENT, {
  name: GROW_GUIDE_COMPONENT,
  path: `/grow-guide/${getPortalId()}`,
  queryParams: getGrowGuideQueryParams(),
  capabilities: [capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.RESTYLE_CAP.getName()],
  iframeProps: {
    id: 'grow-guide',
    style: {
      blockSize: '200px',
      inlineSize: '400px',
      position: 'absolute',
      insetBlockStart: 'calc(var(--global-nav-height, 86px) + 16px)',
      insetInlineStart: 'calc(100% - 400px - 16px)',
      background: 'white',
      zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT,
      transition: 'all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      border: '1px solid black'
    },
    ['data-test-id']: 'grow-guide',
    title: 'Grow Guide'
  }
});